import React, { useState, createContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './App.css';

// Import Components
import Navbar from './components/common/Navbar';
import Home from './components/Home/Home';
import Videos from './components/Videos/Videos';
import Blogs from './components/Blogs/Blogs';
import BlogDetail from './components/Blogs/BlogDetail';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import ThemeToggle from './components/ThemeToggle/ThemeToggle';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import FloatingRequestButton from './components/Request/FloatingRequestButton';
import Products from './components/Products/Products';
import ProductDetail from './components/Products/ProductDetail';
import ThankYou from './pages/ThankYou';

// Create a context for theme
const ThemeContext = createContext();

function App() {
  const [theme, setTheme] = useState('light');

  // Load theme preference from localStorage on component mount
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  // Toggle between light and dark theme
  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <Router>
        <div className={`app ${theme}`}>
          <Navbar />
          <ThemeToggle />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsAndConditions />} />
              <Route path="/thank-you" element={<ThankYou />} />
            </Routes>
          </main>
          <FloatingRequestButton />
          <Footer />
        </div>
      </Router>
    </ThemeContext.Provider>
  );
}

export { ThemeContext };
export default App;

